import { eTipoPermissao } from '@/enums/ePermissoes';

/*
 * CADASTRO DE FUNCIONÁRIOS (NOVO) — o item "Cadastro de Funcionários" do menu ACADÊMICO
 * (legado `MenuAcademico/CadastrarDadosPessoal.aspx`, permissão 301000300).
 *
 * A tela é a MESMA do módulo Pessoal (`/pessoal/pesservidor`): as duas views são reaproveitadas,
 * e o que muda é só a ROTA — e, com ela, a permissão. `meta.permissions` tem SÓ a permissão nova
 * (301000399): quem recebe o cadastro pelo acadêmico não ganha o módulo Pessoal, e vice-versa.
 *
 * As views não conhecem nome de rota fixo: a pesquisa e a ficha se encontram por
 * `meta.rotaListagem` / `meta.rotaCadastro`. Sem isso, o "Pesquisar" da ficha aberta pelo
 * acadêmico levaria à pesquisa do Pessoal — e daria "acesso negado" a quem só tem a permissão
 * nova. Ver docs/pessoal/README.md.
 *
 * O item de menu (Seg_Menu 301000399) abre a FICHA em branco, como o legado: em
 * CadastrarDadosPessoal.aspx.cs o Page_Load chama btnNovo_clicou e deixa carregaSelecionado
 * comentado, e a pesquisa lateral só lista quem for procurado. Aqui a pesquisa é o botão
 * Pesquisar da ficha, que leva à rota academico_cadastrofuncionarios.
 */
const meta = {
  permissions: [eTipoPermissao.CADASTRODEFUNCIONARIOSNOVO_MENU_301000399],
  rotaListagem: 'academico_cadastrofuncionarios',
  rotaCadastro: 'academico_cadastrofuncionarios_cadastro',
  tituloListagem: 'Funcionários',
};

export default [
  {
    description: 'Cadastro de Funcionários',
    path: '/academico/cadastrofuncionarios',
    name: 'academico_cadastrofuncionarios',
    component: () => import('@/views/pessoal/pesservidor/Index.vue'),
    meta,
    goesToMenu: true,
  },
  {
    description: 'Cadastro de Funcionário',
    path: '/academico/cadastrofuncionarios/cadastro/:id?',
    parent: 'academico_cadastrofuncionarios',
    name: 'academico_cadastrofuncionarios_cadastro',
    component: () => import('@/views/pessoal/pesservidor/InclusaoEdicao.vue'),
    meta,
    goesToMenu: true,
  },
];
